const MODULE_NAME = "sc/actions/common/";

export const UI_ERROR = `@@${MODULE_NAME}UI_ERROR`;

export const uiError = uiError => ({
  type: UI_ERROR,
  payload: {
    uiError: uiError,
  },
});

export const clearUIError = () => ({
  type: UI_ERROR,
  payload: {
    uiError: "",
  },
});



// WEBPACK FOOTER //
// ./src/sc/actions/ui/ui-error.js